import React from 'react';
import './RangeContext.styl';
import RangeField from 'components/pure/utils/form/RangeField';

export default class RangeContext extends React.Component {
  getCurrentRange() {
    const {context} = this.props;
    const start = context && context.range && context.range.start;
    const end = context && context.range && context.range.end;
    return {start, end};
  }

  render() {
    const {start, end} = this.getCurrentRange();

    return (
      <div className="range-widget">
        <RangeField
          start={start}
          end={end}
          onValueChange={this.props.valueChange}
          formatLabel={value => ''}
          suffix="%"
        />
      </div>
    );
  }
}
